import type { ReactNode } from "react";

// The device chrome. Everything inside `.iapp-screen` is the end-investor's
// retail app; the bezel/statusbar just sell the "this is a phone" framing for
// the demo. Purely presentational.
export function PhoneFrame({ children }: { children: ReactNode }) {
  return (
    <div className="iapp-device">
      <div className="iapp-notch" />
      <div className="iapp-screen">
        <div className="iapp-statusbar">
          <span>9:41</span>
          <span className="dots">
            <i /><i /><i /><span style={{ marginLeft: 4 }}>􀛨</span>
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}

// The in-app top bar (back chevron + title + Andersen wordmark).
export function AppBar({
  title,
  onBack,
}: {
  title: string;
  onBack?: () => void;
}) {
  return (
    <div className="iapp-appbar">
      {onBack && (
        <button className="back" onClick={onBack} aria-label="Back" type="button">
          ‹
        </button>
      )}
      <span className="title">{title}</span>
      <span className="spacer" />
      <span className="brandtag">Andersen</span>
    </div>
  );
}

// The linear progress bar driven by QP's status.percent (shown as a %).
export function Progress({ percent }: { percent: number }) {
  const pct = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className="iapp-progress">
      <div className="track">
        <div className="fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="cap">
        <span>Your plan</span>
        <span>{pct}%</span>
      </div>
    </div>
  );
}

// A fixed bottom call-to-action.
export function Cta({
  label,
  onClick,
  disabled,
  hint,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  hint?: string;
}) {
  return (
    <div className="iapp-cta">
      <button className="btn-block" onClick={onClick} disabled={disabled} type="button">
        {label}
      </button>
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}
